"use client";
import { clsx as t } from "clsx";
import { twMerge as e } from "tailwind-merge";
function c(...r) {
  return e(t(r));
}
export {
  c as cn
};
//# sourceMappingURL=index15.js.map
